import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img05.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#4041ab" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Team Up with TekRevol’s App Developers in New Jersey to Digitize
              Your Business
            </h2>
            <p>
              Our customized digital software solutions are precisely created to
              align with your diverse objectives, improve your brand visibility,
              and nurture long lasting connections with your audience. With
              TekRevol as your partner, you're not simply adjusting to change –
              you're utilizing it to push your business towards unmatched
              growth.
            </p>
            <p>
              At TekRevol, we know that the catalyst of innovation needs
              accurate leadership to spark brilliance. Our Revolutionary
              advisory services go over simple advice – they work as the
              keystone for transforming your ideas into impactful realities.
              Using our deep understanding of both technology and business, we
              help you in identifying bottlenecks, restructuring workflows, and
              applying solutions that improve your operations.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#4041ab",
                border: "1px solid #4041ab",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
